import { render, staticRenderFns } from "./ReviewMembers.vue?vue&type=template&id=7421b8b4&"
import script from "./ReviewMembers.vue?vue&type=script&lang=js&"
export * from "./ReviewMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports